export default __webpack_public_path__ + "static/media/x_2.72e6b379.svg";